{
  "seo": {
    "title": "Cookie Policy",
    "description": "See what cookies and browser storage CuriPop uses and why."
  },
  "title": "Cookie Policy",
  "updated": "Last updated: {date}",
  "sections": {
    "usage": {
      "title": "How CuriPop Uses Cookies and Storage",
      "body1": "CuriPop uses a combination of browser storage technologies to operate the service, keep users signed in, and remember preferences. At this time, most client-side storage in the web app is implemented through local storage and session storage."
    },
    "storage": {
      "title": "Storage Items Currently Used"
    },
    "thirdParty": {
      "title": "Third-Party Cookies",
      "body1": "During OAuth sign-in flows, third-party identity providers may set their own cookies as part of authentication. Those cookies are managed by the provider under their own policies."
    },
    "preferences": {
      "title": "Managing Preferences",
      "body1": "You can update cookie preferences through the in-app cookie consent controls and can clear local/session storage at any time through your browser settings.",
      "body2": "Clearing required storage may affect login state and some product functionality."
    },
    "contact": {
      "title": "Contact",
      "body": "For questions about this Cookie Policy, contact"
    }
  },
  "table": {
    "name": "Name",
    "type": "Type",
    "purpose": "Purpose",
    "duration": "Duration",
    "required": "Required"
  },
  "storageItems": {
    "items": {
      "consent": {
        "type": "Local storage",
        "purpose": "Stores cookie preference choices (necessary, analytics, marketing).",
        "duration": "Until user clears browser storage",
        "required": "Yes"
      },
      "auth": {
        "type": "Local storage",
        "purpose": "Keeps users signed in and authorizes API requests.",
        "duration": "Until sign-out, token expiry, or user clears browser storage",
        "required": "Yes"
      },
      "user": {
        "type": "Local storage",
        "purpose": "Stores cached user profile details after child login flow.",
        "duration": "Until sign-out or user clears browser storage",
        "required": "Yes"
      },
      "displayCount": {
        "type": "Session storage",
        "purpose": "Remembers how many Explore items were displayed in current tab session.",
        "duration": "Current browser tab session",
        "required": "Yes"
      },
      "scroll": {
        "type": "Session storage",
        "purpose": "Restores Explore page scroll position in current tab session.",
        "duration": "Current browser tab session",
        "required": "Yes"
      }
    }
  }
}
